import React, { useState } from 'react';
import { View, Text, Pressable, StyleSheet } from 'react-native';

type TooltipProps = {
  content: string;
  children: React.ReactNode;
};

export const Tooltip = ({ content, children }: TooltipProps) => {
  const [visible, setVisible] = useState(false);

  const handleMouseEnter = () => setVisible(true);
  const handleMouseLeave = () => setVisible(false);
  return (
    // @ts-ignore
    <View style={styles.wrapper} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <Pressable>{children}</Pressable>
      {visible && (
        <View style={styles.tooltip}>
          <Text style={styles.tooltipText}>{content}</Text>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center'
  },
  tooltip: {
    position: 'absolute',
    bottom: 25,
    backgroundColor: 'black',
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 6,
    zIndex: 10,
    maxWidth: 200
  },
  tooltipText: {
    color: 'white',
    fontSize: 14,
    textAlign: 'center'
  }
});
